import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=51163576&scoped=true"
import script from "./calendar.vue?vue&type=script&setup=true&lang=js"
export * from "./calendar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./calendar.vue?vue&type=style&index=0&id=51163576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51163576",
  null
  
)

export default component.exports